var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDemoPlay = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 81,
    viewBox: "0 0 82 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.2438 40.2235C81.2438 62.4383 63.2351 80.4469 41.0203 80.4469C18.8055 80.4469 0.796875 62.4383 0.796875 40.2235C0.796875 18.0087 18.8055 0 41.0203 0C63.2351 0 81.2438 18.0087 81.2438 40.2235Z",
    fill: "#FAC300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1924 40.2235L30.5271 59.898L30.5271 20.5489L64.1924 40.2235Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDemoPlay);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/demo-play.ab20fc12119b80b9b985b1cac41d52ac.svg";